import Newsletter from 'components/Newsletter'
import CartDetails from 'containers/CartDetails'
import OrderActions from 'containers/OrderActions'
import { hasCartProductsSelector } from 'modules/cart/selectors'
import { ROUTE_PATH_WITH_CUSTOM_SIDEBAR } from 'modules/routes/constants/index.cjs'
import {
  STYLES_MARGIN,
  STYLES_SIDEBAR_WIDTH_DESKTOP
} from 'modules/styles/constants/index.cjs'
import getCurrentUserSelector from 'modules/users/selectors/get-current'
import React from 'react'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'
import shouldShowNewsletterSelect from 'modules/newsletter/redux/selectors/should-show/index.js'

export default function Sidebar ({
  location,
  route,
  match
}) {
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)
  const currentUser = useSelector(getCurrentUserSelector())
  const hasCartProducts = useSelector(hasCartProductsSelector())
  const shouldShowNewsletter = useSelector(shouldShowNewsletterSelect)

  let element
  if (
    currentUser &&
    location.pathname.startsWith(ROUTE_PATH_WITH_CUSTOM_SIDEBAR.ORDERS) &&
    match?.params?.key
  ) {
    element = (
      <OrderActions
        route={route}
        match={match}
      />
    )
  }

  if (
    currentUser &&
    !element &&
    hasCartProducts
  ) {
    element = <CartDetails match={match} />
  }

  return (
    <div
      style={{
        minWidth: '18em',
        boxSizing: 'border-box',
        padding: isSmallScreen
          ? '0'
          : `${STYLES_MARGIN.MEDIUM} ${STYLES_MARGIN.MEDIUM} ${STYLES_MARGIN.MEDIUM} 0`,
        width: isSmallScreen
          ? '100%'
          : STYLES_SIDEBAR_WIDTH_DESKTOP
      }}
    >
      {element}
      {!!shouldShowNewsletter && <Newsletter />}
    </div>
  )
}
